import { getPieRadius } from '../../utils/chart';
import { textColor } from '../../theme/common/color'; // 普通环形的外半径与环形的内半径的比例

var normalRingRatio = 1.5;
export default function (chart, config) {
  var radius = getPieRadius(chart.radius); // set inside radius

  chart.radius[0] = radius.outside / normalRingRatio + "%";

  if (!config.labelLine) {
    chart.label.normal.position = 'center';
    chart.label.normal.rich = {
      name: {
        fontSize: 16,
        padding: 8,
        color: textColor.gray
      },
      value: {
        fontSize: 25,
        color: textColor.normal
      }
    };
  }
}